import { BaseService } from "./BaseService";
import { SnackBarModule } from "../modules/SnackBarModule";

export const MapeamentoFeriasService = {
  async listarMapeamentoFerias(postData) {
    const response = await BaseService.fetchResponseFromAPIPost(`mapeamento`, postData);
    if (response.error) {
      SnackBarModule("Houve um erro ao listar as unidades", "error");
    }
    return response.message;
  },

  async getUsuarios(lotacao) {
    const response = await BaseService.fetchResponseFromAPIGet(`mapeamento/usuarios-lotacao/${lotacao}`);

    if (response.error) {
      SnackBarModule("Houve um erro ao listar os usuários a partir de uma lotação", "error");
    }
    return response.content;
  },
  
  async listarFeriasPendentesAprovacao(page) {
    const response = await BaseService.fetchResponseFromAPIGet(`mapeamento/pendentes?page=${page}`);
    if (response.error) {
      console.error("Houve um erro ao listar as ferias pendentes de aprovação");
    }
    return response.content;
  },

  async listaSemAgendamento(postData) {
    const response = await BaseService.fetchResponseFromAPIPost(`mapeamento/sem-agendamento`, postData);
    if (response.error) {
      console.error("Houve um erro ao listar as ferias sem agendamento");
    }
    return response.message;
  },

  async listarMetricasUnidade(postData) {
    const response = await BaseService.fetchResponseFromAPIPost(`mapeamento/metricas-unidade`, postData);
    if (response.error) {
      console.error("Houve um erro ao listar as métricas por unidade");
    }
    return response.message;
  },

  async buscarFeriasPorMes(mes) {
    const response = await BaseService.fetchResponseFromAPIGet(`mapeamento/${mes}`);
    if (response.error) {
      console.error("Houve um erro ao listar as ferias por mês");
    }
    return response.content;
  },

}